var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import merge from 'deepmerge';
import configureTooltip from '../tooltip/main';

var buildBulletConfiguration = function buildBulletConfiguration(widgetConfig, chartConfig, seriesDataObj, customConfig) {
    var seriesConfig = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    var seriesData = void 0,
        actualValue = void 0,
        targetValue = void 0,
        categoryAxis = void 0,
        tooltipValue = void 0,
        config = void 0;

    var seriesType = "bullet";
    var dataRow = seriesDataObj[0];

    if (widgetConfig.BulletConfig.Series[0].CategoryAxis) {
        actualValue = chartConfig.Series[0]["ActualValue"];
        targetValue = chartConfig.Series[0]["TargetValue"];
        categoryAxis = chartConfig.Series[0]["CategoryAxis"];
        config = chartConfig.Series[0];
        if (chartConfig.Series[0].Tooltip.TooltipConfigs.length) {
            tooltipValue = chartConfig.Series[0].Tooltip.TooltipConfigs[0].Id;
            seriesData = [_extends({}, dataRow, {
                y: dataRow[actualValue],
                target: dataRow[targetValue],
                crumbValue: dataRow[categoryAxis],
                name: dataRow[categoryAxis],
                value: dataRow[actualValue],
                tooltip: tooltipValue,
                DefaultPerspective: seriesConfig.DefaultPerspective
            })];
        } else {
            var _ref;

            seriesData = [(_ref = {
                y: dataRow[actualValue],
                target: dataRow[targetValue],
                value: dataRow[actualValue],
                crumbValue: dataRow[categoryAxis],
                name: dataRow[categoryAxis]
            }, _ref[categoryAxis] = dataRow[categoryAxis], _ref[tooltipValue] = dataRow[tooltipValue], _ref.DefaultPerspective = seriesConfig.DefaultPerspective, _ref)];
        }
    } else {
        actualValue = chartConfig["ActualValue"];
        targetValue = chartConfig["TargetValue"];
        config = chartConfig;
        if (chartConfig.Tooltip.TooltipConfigs.length) {
            var _ref2;

            tooltipValue = chartConfig.Tooltip.TooltipConfigs[0].Id;
            seriesData = [(_ref2 = {
                y: dataRow[actualValue],
                target: dataRow[targetValue],
                tooltip: tooltipValue
            }, _ref2[tooltipValue] = dataRow[tooltipValue], _ref2)];
        } else {
            seriesData = [{
                y: dataRow[actualValue],
                target: dataRow[targetValue]
            }];
        }
    }

    return merge({
        data: seriesData,
        tooltip: configureTooltip(seriesType, config)
    }, customConfig);
};

export default buildBulletConfiguration;